import { type CollectibleEventListRefined, type FetchCollectibleEventsParams, queryClient } from '@capsicum/common';
import { useMainCurrenciesQuery } from '@capsicum/socios-core';
import { useMemo } from 'react';

import {
	useCollectibleEventsQueries,
	UseCollectibleEventsQueryKeyBuilder
} from '../data-access/queries/useCollectibleEventsQueries';

export const useAuctionsById = (sportEventId: string, auctionsPerEvent?: number) => {
	const { data: currencies } = useMainCurrenciesQuery();
	const { altCurrency, defaultCurrency } = currencies ?? {};

	const params: FetchCollectibleEventsParams = {
		altCurrencyId: altCurrency?.id,
		'ids[]': [sportEventId],
		mainCurrencyId: defaultCurrency?.id,
		...(auctionsPerEvent ? { auctionsPerEvent } : {})
	};

	const {
		data,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		isLoading,
		refetch: refetchEvents
	} = useCollectibleEventsQueries(params);

	const events: Array<CollectibleEventListRefined> = useMemo(
		() =>
			(data &&
				data?.pages.flatMap(page => {
					return page?.data || [];
				})) ??
			[],
		[data]
	);

	const eventClosed = useMemo(() => {
		if (!events[0]) {
			return false;
		}

		return !events[0]?.auctions?.filter?.(auction => auction?.status !== 'finished').length;
	}, [events]);

	//TODO: MULTIPARTNER EVENT LOGIC HERE
	const auctionsArray = events[0]?.auctions || [];

	return {
		auctionsArray,
		eventClosed,
		events,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		isLoading,
		refetchEvents,
		remove: () => queryClient.removeQueries({ queryKey: UseCollectibleEventsQueryKeyBuilder(params) })
	};
};
